import React from 'react';
import Avatar from '../../avatar/avatar';
import Icon from '../../Atoms/icon/icon';
import { IconscoutIcons } from '../../Atoms/icon/iconscout-icon';

import BackImage from './testimonial-background.png';
import StarIcon from './star.svg';

export interface ITestimonialSecondaryProps {
  rate: number;
  avatarImgSrc: string;
  name: string;
  position: string;
  location: string;
  text: string;
}
export function TestimonialSecondary({
  rate,
  avatarImgSrc,
  name,
  position,
  location,
  text,
}: ITestimonialSecondaryProps) {
  return (
    <div className="testimonial-secondary">
      <img className="testimonial-secondary__backdrop-image" src={BackImage} />
      <div className="testimonial-secondary__header">
        <Avatar imgSrc={avatarImgSrc} />
        <div className="testimonial-secondary__header__author-info">
          <div className="testimonial-secondary__header__author-info__name">{name}</div>
          <div className="testimonial-secondary__header__author-info__position">{position}</div>
        </div>
      </div>

      <div className="testimonial-secondary__location">
        <div className="testimonial-secondary__location__label">
          <Icon icon={IconscoutIcons.MAP_MARKER} /> Location
        </div>
        <div className="testimonial-secondary__location__value">{location}</div>
      </div>

      <div className="testimonial-secondary__rate">
        <img src="https://a.storyblok.com/f/223514/232x25/ad24af15ed/clutch_logo.svg" alt="clutch" />
        <div className="testimonial-secondary__rate__stars">
          {Array.from({ length: rate }).map((_, i) => (
            <img key={i} src={StarIcon as any} />
          ))}
        </div>
      </div>

      <p className="testimonial-secondary__text">{`"${text}"`}</p>
    </div>
  );
}
